module.exports = __webpack_public_path__ + "static/media/g3.5aec4bf2.png";